export const NoRounding = 1;
export const RoundToNearest5Cent = 2;
export const RoundDownTo0Cent = 3;
